import React from "react";
import {Nav, Tab, Card} from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";
import fineLogo from '../../Assets/Fine_ES_Logo.png'
import WataruChibi from '../../Assets/Image/(Unbridled_Existence)_Wataru_Hibiki_Chibi.webp'
import WataruSound from '../../Assets/Sound/vo_wataru_emo_general_13.mp3'
import ClickMeAnimation from "../Fun/ChibiButton";
import WataruHead from '../../Assets/Image/wataru_head.png'

function ProfileCard() {
  return (
    <Card className="box-card">
    <Tab.Container  id="home-page" defaultActiveKey="Home">
          <Nav variant="pills" fill className="navi-custom">
            <Nav.Item>
              <Nav.Link eventKey="Home">Profile</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="About">Blurb</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Extra">More</Nav.Link>
            </Nav.Item>
          </Nav>
    <Tab.Content>
            <Tab.Pane eventKey="Home">
      <Card.Body>
        <div className="table-responsive">
        <Table className="profileTable">
        <tbody>
          <tr><td>Alias: </td>
            <td>rai, kuno</td>
            <td>Age: </td>
            <td>27+</td></tr>
          <tr><td>Pronouns: </td>
            <td>they/them</td>
            <td>Found in: </td>
            <td>USA</td></tr>
          <tr><td>Ability: </td>
          <td>Programming</td>
          <td> Roleplaying</td>
          <td> Idol Games</td></tr>
          <tr><td>Currently Playing: </td>
            <td colSpan={3}>Genshin Impact</td></tr>
            <tr><td>Listening to: </td>
            <td colSpan={3}>Eccentric Party Night!!</td></tr>
        </tbody>
        </Table>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>

    <Tab.Content>
    <Tab.Pane eventKey="About">
      <Card.Body>
      <div className="profile">
          <Row>
           <Col xs={4}><img style={{maxWidth: "100%"}} src="https://static.wikia.nocookie.net/pokemon/images/e/ea/Alola_Raichu_SS.gif"/></Col> 
           <Col xs={8}>
          <div className="profile-body">
         <p>Hello! My name is <strong>rai</strong>! I also go by kuno! I'm just your local raichu who loves idol games and memes!</p>
         <p>If you're here to look for the ensemble stars assets drive or any other renders drive, check out my <a href="https://gradualcolors.github.io/#/assetdrives" target="_blank">asset drives</a> page!</p>      
        </div>
        </Col>        
        </Row>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    <Tab.Content>
    <Tab.Pane eventKey="Extra">
      <Card.Body>
      <div className="profile">
      <ul className="bulletsCustom">
      <li>I'm an IT professional! My specialties are programming and web design. I like using my own skills to dabble in my love for idols. Please check out my projects at <a href="https://gradualcolors.github.io/#/project" target="_blank">@gradualcolors</a>!</li>
      <li>I am <strong>Asian</strong>, <strong>non-binary</strong>, and <strong>pansexual</strong>.</li>
      <li>Established roleplayer of 10+ years. You may see me around in discord rp groups. My current main muse is <strong>Natsume Sakasaki</strong>.</li>
      <li>I love cute animals, especially cats, bunnies and owls.</li>
      <li>I'm blessed with a terrifying tenacity to fulfill my goals when it comes to coding.</li>
      <li>I constantly lovemail my <Link to="/interests">biases</Link>. ♡</li>

</ul>

</div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    </Tab.Container>

    <div className="profileFooter">
        <Row>
        <Col xs={4}>
        <img className="logo" src={fineLogo}/>
        </Col>
        <Col xs={8}>
        <ClickMeAnimation head={WataruHead} img={WataruChibi} sound={WataruSound}/>
        </Col>
        </Row>
    </div>
    </Card>
  );
}

export default ProfileCard;

